import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Phone, ExternalLink } from "lucide-react";
import { STATUSES } from "./useLeadDetail";

export default function LeadDetailHeader({ lead }) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-4 mb-6">
      <button onClick={() => navigate("/leads")} className="btn-ghost p-2" data-testid="back-to-leads">
        <ArrowLeft size={20} />
      </button>
      <div className="flex-1">
        <div className="flex items-center gap-3">
          {lead.source === "wati" && <span className="whatsapp-indicator" />}
          <h1 className="text-2xl font-medium text-[#1C1917]" style={{ fontFamily: "Playfair Display, serif" }}>
            {lead.name}
          </h1>
          <span className={`status-${lead.status} px-2 py-0.5 text-xs uppercase tracking-wider rounded-sm`}>
            {STATUSES.find((s) => s.value === lead.status)?.label || lead.status}
          </span>
        </div>
        <p className="text-[#57534E] flex items-center gap-2 mt-1">
          <Phone size={14} /> {lead.phone}
          {lead.product_link && (
            <a href={lead.product_link} target="_blank" rel="noopener noreferrer" className="text-[#BC4B35] flex items-center gap-1 hover:underline">
              <ExternalLink size={14} /> Product
            </a>
          )}
        </p>
      </div>
    </div>
  );
}
